<template>
  <div>
    <!-- 找回密码弹窗 -->
    <iModal
      name="retrieve-password"
      title="找回密码"
      @on-cancel="cancelHandle"
      v-model="open"
      @input="handleInput"
      width="650"
      :mask-closable="false"
    >
      <template v-if="!isResetPassword">
        <template v-if="!password">
          <!-- 选择找回密码方式 -->
          <div class="btn-group" v-if="changePasswordType === ''">
            <div
              class="s-btn-red"
              @click="openChangePassword('phone')"
              v-if="userData.phoneNumber"
            >
              手机号验证找回
            </div>
            <div
              class="s-btn-red"
              @click="openChangePassword('email')"
              v-if="userData.email"
            >
              邮箱验证找回
            </div>
            <p v-if="!userData.phoneNumber && !userData.email">
              如忘记登入密码，无法正常登入展商中心的，请联系：010-84556507进行密码重置。带来不便，敬请谅解~
            </p>
          </div>

          <!-- 验证表单 -->
          <Form
            v-else
            ref="formReset"
            :model="formReset"
            :rules="ruleReset"
            :label-width="120"
          >
            <FormItem label="用户名：" prop="user">
              <Input
                type="text"
                style="width: 100%"
                v-model="formReset.user"
                placeholder="请输入用户名"
                disabled
              />
            </FormItem>
            <FormItem
              label="绑定手机："
              prop="phone"
              v-if="changePasswordType === 'phone'"
            >
              <Input
                type="text"
                style="width: 100%"
                v-model="formReset.phone"
                placeholder="请输入手机号码"
                disabled
              />
            </FormItem>
            <FormItem label="绑定邮箱：" prop="email" v-else>
              <Input
                type="text"
                style="width: 100%"
                v-model="formReset.email"
                placeholder="请输入邮箱"
                disabled
              />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha">
              <Input
                type="text"
                v-model="formReset.captcha"
                placeholder="请填写验证码"
                style="width: 500px"
              />
              <Button
                type="text"
                v-if="showCode"
                @click.prevent="getCaptcha('formReset')"
                class="form-code-btn"
                >获取验证码</Button
              >
              <Button type="text" v-else disabled class="form-code-btn"
                >{{ count }}s后重新获取</Button
              >
            </FormItem>
            <FormItem label="" prop="">
              <p>
                如果没有绑定{{
                  changePasswordType === "phone" ? "手机" : "邮箱"
                }}或忘记所绑定的{{
                  changePasswordType === "phone" ? "手机" : "邮箱"
                }}请联系：010-84556507进行密码重置
              </p>
            </FormItem>
          </Form>
        </template>
        <p v-else style="margin: 40px 0; text-align: center">
          验证成功！您的密码是：{{ password }}，请妥善保存。
        </p>
      </template>
      <template v-else>
        <Form ref="formReset1" :model="formReset1" :rules="ruleReset1" :label-width="120">
          <FormItem label="新密码：" prop="password">
            <Input
              style="width: 100%"
              v-model="formReset1.password"
              name="password"
              placeholder="请输入您的新密码"
              v-trim
            />
          </FormItem>
          <FormItem label="确认密码：" prop="copyPassword">
            <Input
              style="width: 100%"
              v-model="formReset1.copyPassword"
              name="copyPassword"
              placeholder="请再次输入您的新密码"
              v-trim
            />
          </FormItem>
        </Form>
      </template>
      <template #footer>
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div>
            <Button
              type="text"
              style="color: #db2a4b"
              @click="resetPasswordHandle"
              v-if="password"
              >重置密码</Button
            >
          </div>
          <div>
            <Button type="primary" class="s-btn-red" @click="submitHandle">确定</Button>
            <Button @click="cancelHandle">取消</Button>
          </div>
        </div>
      </template>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { validator } from "@/other/validator";

export default {
  name: "RetrievePassword",
  props: {
    // 控制弹窗显示隐藏
    open: {
      type: Boolean,
      default: false,
    },
    // 用户数据
    userData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      changePasswordType: "", // 选择验证类型 phone or email
      formReset: {
        user: "", // 用户名
        phone: "", // 手机号
        email: "", // 邮箱
        captcha: "", // 验证码
      },
      ruleReset: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      ruleReset1: {
        password: validator.password,
        copyPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regex = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*\d)(?=.*[\W_])|(?=.*[A-Z])(?=.*\d)(?=.*[\W_])).{8,}$/;
              if (!value) {
                callback("请输入密码");
              } else if (regex.test(value)) {
                callback();
              } else {
                callback(
                  "密码均应在8位以上，并具有大小写字母、数字、符号等至少两种以上的组合"
                );
              }
            },
            trigger: "blur",
          },
        ],
      },
      showCode: true, // 是否显示获取验证码按钮
      count: "", // 倒计时数值
      password: "", // 密码值
      timer: "",
      isResetPassword: false, // 是否重置密码
      formReset1: {
        password: "",
        copyPassword: "",
      },
      forbiddenChars: ["1", "I", "0", "o", "O", "l", " "], // 禁止输入的字符
    };
  },
  methods: {
    ...mapActions({
      getMsgCode: "exhibitionModule/getMsgCode",
      getEmailVerCode: "exhibitionModule/getEmailVerCode",
      validatePhoneOrEmail: "companyModule/validatePhoneOrEmail", // 验证手机号和邮箱是否正确
      changePasswordByOld: "loginModule/changePasswordByOld",
      SaveResetForgetPassword: "companyModule/SaveResetForgetPassword",
    }),
    // 提交表单
    submitHandle() {
      if (this.isResetPassword) {
        // 重置密码表单验证
        this.$refs.formReset1.validate(async (valid) => {
          if (!valid) return;
          try {
            let formData = {
              userName: this.userData.userName,
              phoneNumber: this.userData.phoneNumber,
              email: this.userData.email,
              vcode: this.formReset1.captcha,
              newPassword: this.formReset1.password,
            };
            let bool = await this.SaveResetForgetPassword(formData);
            if (!bool) {
              this.$Message.error("修改失败，请重新尝试!");
              return false;
            }
            if (bool.errors && bool.errors[0]) {
              if (bool.errors[0].code === -1) {
                this.$Message.error("密码有误，请确认修改");
                return;
              }
              this.$Message.error(bool.errors[0].description);
              return;
            }
            this.resetForm();
            this.$Message.success("修改成功!");
          } catch (error) {
            this.$Message.error("密码重置失败");
          }
        });
      } else {
        // 原有的验证逻辑
        this.$refs.formReset.validate(async (valid) => {
          if (!valid) return;
          let opt = {
            userName: this.formReset.user,
            vcode: this.formReset.captcha,
          };
          if (this.changePasswordType == "phone") {
            opt.phoneNumber = this.formReset.phone;
          } else {
            opt.email = this.formReset.email;
          }
          let bool = await this.validatePhoneOrEmail(opt);

          if (bool && bool.successed) {
            this.password = bool.info.loginPassWord;
            this.$Message.success("验证成功");
          } else {
            if (bool.errors[0].description) {
              this.$Message.warning(bool.errors[0].description);
            } else {
              this.$Message.warning("修改失败，请重试！");
            }
          }
        });
      }
    },

    // 处理弹窗显示状态变化
    handleInput(value) {
      this.$emit("update:open", value);
    },

    // 关闭弹窗
    cancelHandle() {
      this.$emit("update:open", false);
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.changePasswordType = "";
      this.password = false;
      this.formReset = {
        user: "",
        phone: "",
        email: "",
        captcha: "",
      };
      this.showCode = true; // 是否显示获取验证码按钮
      this.count = ""; // 倒计时数值
      this.password = ""; // 密码值
      this.timer = "";
      this.isResetPassword = false; // 是否重置密码
      this.formReset1 = {
        password: "",
        copyPassword: "",
      };
      if (this.$refs.formReset) {
        this.$refs.formReset.resetFields();
      }
      this.$emit("update:open", false);
      this.$emit("resetForm");
    },

    // 获取验证码
    async getCaptcha() {
      let valid1 = null;
      if (this.changePasswordType == "phone") {
        valid1 = await this.validField("phone");
      } else {
        valid1 = await this.validField("email");
      }
      let valid2 = await this.validField("user");
      if (valid1 || valid2) return;
      this.changePasswordType == "phone" && this.downTimeMob(name);
      this.changePasswordType == "email" && this.downTime(name);
    },
    async downTime() {
      let opt = {
        Email: this.formReset.email,
        Language: "2",
      };
      const valid = await this.getEmailVerCode(opt);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async downTimeMob() {
      let opt = {
        Phone: this.formReset.phone,
        Language: "2",
      };
      const valid = await this.getMsgCode(opt);
      if (!valid.successed) {
        this.$Message.warning("请输入有效手机号");
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    // 选择找回密码方式
    openChangePassword(type) {
      this.changePasswordType = type;
      this.formReset.user = this.userData.userName;
      if (type === "phone") {
        this.formReset.phone = this.userData.phoneNumber;
      } else {
        this.formReset.email = this.userData.email;
      }
    },

    validField(name) {
      // 验证单个表单
      return new Promise((resolve, reject) => {
        this.$refs.formReset.validateField(name, (valid) => {
          resolve(valid);
        });
      });
    },
    resetPasswordHandle() {
      this.isResetPassword = true;
      this.formReset1 = {
        password: "",
        copyPassword: "",
      };
    },
  },
  watch: {
    "formReset1.password": {
      handler(newVal) {
        if (!newVal) return;
        const filteredValue = newVal
          .split("")
          .filter((char) => !this.forbiddenChars.includes(char))
          .join("");

        if (newVal !== filteredValue) {
          this.$Message.warning(
            `包含禁止使用的字符：${this.forbiddenChars.join("、")}`.replace(" ", "空格")
          );
          this.$nextTick(() => {
            this.formReset1.password = filteredValue;
          });
        }
      },
      immediate: true,
    },
    "formReset1.copyPassword": {
      handler(newVal) {
        if (!newVal) return;
        const filteredValue = newVal
          .split("")
          .filter((char) => !this.forbiddenChars.includes(char))
          .join("");

        if (newVal !== filteredValue) {
          this.$Message.warning(
            `包含禁止使用的字符：${this.forbiddenChars.join("、")}`.replace(" ", "空格")
          );
          this.$nextTick(() => {
            this.formReset1.copyPassword = filteredValue;
          });
        }
      },
      immediate: true,
    },
  },
  directives: {
    trim: {
      inserted(el) {
        const input = el.querySelector("input") || el;
        input.addEventListener("blur", () => {
          if (input.value) {
            input.value = input.value.trim();
            input.dispatchEvent(new Event("input"));
          }
        });
      },
    },
  },
};
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 20px 0;
}

.form-code-item {
  display: flex;
  align-items: center;
}

.form-code-btn {
  margin-left: 10px;
  white-space: nowrap;
}

.btn-group {
  margin: 40px 80px;
  .s-btn-red {
    padding: 10px 0;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    width: 100%;
  }
  .s-btn-red:first-child {
    margin-bottom: 20px;
  }
}

.form-code-item {
  position: relative;

  .form-code-btn {
    position: absolute;
    right: 1px;
    height: 28px;
    top: 3px;
    border: none;
    outline: none;

    &:focus {
      box-shadow: none;
      border: none;
      outline: none;
    }
  }
  ::v-deep .ivu-form-item-content {
    margin: 0 !important;
  }
}
</style>
